/*
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-11 11:52:24
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-11 14:33:12
 * @FilePath: \zhucai_user\src\api\qbank.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/util/request";

export function Exercise_GetList(params) {
  return request({
    url: "/pc/QBank/Exercise_GetList",
    method: "get",
    params,
  });
}
export function Exercise_GetClassifys(params) {
  return request({
    url: "/pc/QBank/Exercise_GetClassifys",
    method: "get",
    params,
  });
}
export function Exercise_GetDetail(params) {
  return request({
    url: "/pc/QBank/Exercise_GetDetail",
    method: "get",
    params,
  });
}
export function Exercise_GetRelatedExercises(params) {
  return request({
    url: "/pc/QBank/Exercise_GetRelatedExercises",
    method: "get",
    params,
  });
}
